import React from 'react';
import { ModalFooter as BootstrapModalFooter } from 'reactstrap';
import PropTypes from 'prop-types';

const ModalFooter = ({
  children,
  ...props
}) => (
  <BootstrapModalFooter {...props}>
    {children}
  </BootstrapModalFooter>
);

ModalFooter.propTypes = {
  children: PropTypes.node,
};

ModalFooter.defaultProps = {
  children: null,
};

export default ModalFooter;
